export const LONG_PROCESS_MESSAGE = "This process takes some time to complete";

export const FILTER_RENAME_NOTICE =
  "This name will be updated for all places referencing this filter.";
